export default ($subnav = null) => {
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';

  // Close both (new search for instance)
  if ($subnav === null) {
    $(`[data-${prefix}form] .filter-filtering`).removeClass('active');
    $(`[data-${prefix}form] .filter-sorting`).removeClass('active');

    $(`[data-${prefix}show-desktop-filter-nav]`).attr('aria-expanded', false);
    $(`[data-${prefix}show-desktop-sort-nav]`).attr('aria-expanded', false);

    $(`[data-${prefix}filter-by]`).attr('tabindex', '-1');
    $(`[data-${prefix}sort-by]`).attr('tabindex', '-1');

    if ($('[data-change-grid]').length) {
      const $grid_icons = $(`[data-${prefix}form]`).closest('.filters-panel-v2__actions').find('[data-change-grid-parent]');
      if ($grid_icons.length > 0) {
        $(`[data-${prefix}form]`).closest('.filters-panel-v2__actions').find('[data-change-grid-parent]').removeClass('visually-hidden');
      }
    }

    $(window).trigger('scroll');
    return;
  }

  $subnav.parent().removeClass('active');
  $subnav.attr('aria-expanded', false);

  const is_filter = ($subnav.attr('aria-controls') === 'filterBy');
  if (is_filter) {
    const $filter_by = $subnav.parent().find(`[data-${prefix}filter-by]`);
    $filter_by.attr('tabindex', '-1');

    if ($('[data-change-grid]').length) {
      const $grid_icons = $subnav.closest('.filters-panel-v2__actions').find('[data-change-grid-parent]');
      if ($grid_icons.length > 0) {
        $subnav.closest('.filters-panel-v2__actions').find('[data-change-grid-parent]').removeClass('visually-hidden');
      }
    }
  } else {
    const $sort_by = $subnav.parent().find(`[data-${prefix}sort-by]`);
    $sort_by.attr('tabindex', '-1');
  }
};
